// extracted by mini-css-extract-plugin
export default {"statusHistoryBlock":"bidSteps_statusHistoryBlock__HbOvz"};